import { Flex } from "@gravity-ui/uikit";

import { PriceProps } from "../../../../PriceProps";
import { ProductInfo } from "../ProductInfo";
import { ProductOffers } from "../ProductOffers";
import { ProductPriceDetails } from "../ProductPriceDetails";
import { ProductPriceStatus } from "../ProductPriceStatus";
import { ProductPriceSummary } from "../ProductPriceSummary";
import { ProductStorePicker } from "../ProductStorePicker";

type ProductPriceSectionProps = PriceProps & {
  isDesktop: boolean;
};

export const ProductPriceSection = ({
  isLoading,
  blurPrice,
  variants,
  selected,
  onChange,
  activeVariant,
  isDesktop,
  isBlur,
  hasLoadError,
  hasPrices,
  platformLabel,
  onRetry,
  showSelectPlatformPrompt,
  stores,
  selectedStore,
  onStoreChange,
  priceSummary,
  valuesWithoutStore,
  variantStores,
  storeGroups,
}: ProductPriceSectionProps) => {
  const hasStoreOffers = storeGroups.length > 0;

  if (!isBlur && !isLoading && (hasLoadError || !hasPrices)) {
    return (
      <ProductPriceStatus
        kind={hasLoadError ? "error" : "empty"}
        platformLabel={platformLabel}
        onRetry={onRetry}
      />
    );
  }

  return (
    <Flex direction="column" gap="4">
      <ProductPriceDetails
        isLoading={isLoading}
        isBlur={isBlur}
        variants={variants}
        selected={selected}
        onChange={onChange}
        valuesWithoutStore={valuesWithoutStore}
      />

      {!isBlur && !isLoading && (
        <ProductStorePicker
          stores={stores}
          variantStores={variantStores}
          value={selectedStore}
          onChange={onStoreChange}
        />
      )}

      {!isBlur && !isLoading && hasStoreOffers ? (
        <Flex direction="column" gap="3">
          <ProductPriceSummary summary={priceSummary} />
          <ProductOffers
            groups={storeGroups}
            isSingleStore={storeGroups.length === 1}
          />
        </Flex>
      ) : (
        <ProductInfo
          isLoading={isLoading}
          isBlur={isBlur}
          blurPrice={blurPrice}
          showSelectPlatformPrompt={showSelectPlatformPrompt}
          activeVariant={activeVariant}
          isDesktop={isDesktop}
        />
      )}
    </Flex>
  );
};
